// The landing page is served as static server-rendered HTML from public/index.html
// (generated from the backend Jinja template). React mounts nothing here.
export default function App() {
  return null;
}
